import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


// import './App.css';
import './Reset.css';
import './Style.css';
import './Custom.css';
import "./Sitemap.css";
import ScrollToTop from './components/ScrollToTop.js';
import useDocumentTitle from './components/useDocumentTitle.js';
import { useConfig } from './components/ConfigContext.js';
import CanonicalTag from "./components/CanonicalTag.js";

const Home = React.lazy(() => import('./components/Home.js'));
const NewHome = React.lazy(() => import('./components/NewHome.js'));
const NewHomeOptimized = React.lazy(() => import('./components/NewHomeOptimized.js'));
const NewHomePageV2 = React.lazy(() => import('./components/NewHomePageV2.js'));
const HomeTest = React.lazy(() => import('./components/Home1.js'));
const AboutUs = React.lazy(() => import('./components/AboutUs.js'));
const Location = React.lazy(() => import('./components/location/Location.js'));
const LocationDetails = React.lazy(() => import('./components/location/LocationDetails.js'));
const LocationDoctorProfile = React.lazy(() => import('./components/location/LocationDoctorProfile.js'));
const Product = React.lazy(() => import('./components/Product.js'));
const Media = React.lazy(() => import('./components/Media.js'));
const ConditionsTreatments = React.lazy(() => import('./components/ConditionsTreatments.js'));
const Careers = React.lazy(() => import('./components/carrier/Careers.js'));
const Search = React.lazy(() => import('./components/Search.js'));
const Blog = React.lazy(() => import('./components/blog/Blog.js'));
const BlogListing = React.lazy(() => import('./components/blog/BlogListing.js'));
const BlogDetails = React.lazy(() => import('./components/blog/BlogDetails.js'));
const DoctorProfile = React.lazy(() => import('./components/blog/DoctorProfile.js'));
const FaqPage = React.lazy(() => import('./components/FaqPage.js'));
const TreatmentPage = React.lazy(() => import('./components/TreatmentPage.js'));
const ContentPage = React.lazy(() => import('./components/ContentPage.js'));
const LocationMduDoctorProfile = React.lazy(() => import('./components/location/LocationsMduDoctorProfile.js'));
const SmileTest = React.lazy(() => import('./components/SmileTest.js'));
const SmileTestNew = React.lazy(() => import('./components/SmileTestNew.js'));
const SmileTestAll = React.lazy(() => import('./components/SmileTestAll.js'));
const SmileTestNewAll = React.lazy(() => import('./components/SmileTestNewAll.js'));
const SmileTestNewV13Q = React.lazy(() => import('./components/SmileTestNewV13Q.js'));




const LandingPage = React.lazy(() => import('./components/LandingPage.js'));
const LandingPagenew = React.lazy(() => import('./components/LandingPagenew.js'));
const LandingPageCoupon = React.lazy(() => import('./components/LandingPageCoupon.js'));
const LandingPagenewDynamic = React.lazy(() => import('./components/LandingPagenewDynamic.js'));
const LandingPagenewDynamicOTP = React.lazy(() => import('./components/LandingPagenewDynamicOTP.js'));
const BracesCost = React.lazy(() => import('./components/BracesCost.js'));



const LandingPageBrands = React.lazy(() => import('./components/LandingPageBrands.js'));


const LandingPageDoctor = React.lazy(() => import('./components/LandingPagenew-doctor'));
const LandingPagePulm = React.lazy(() => import('./components/LandingPagePulm'));
const LandingPageMg = React.lazy(() => import('./components/LandingPageMg'));

const LandingPageOtp = React.lazy(() => import('./components/LandingPageOtp.js'));
const Testimonials = React.lazy(() => import('./components/Testimonials.js'));
const SmileAssesmentNew = React.lazy(() => import('./components/SmileAssesmentNew.js'));
const SmileAssesment = React.lazy(() => import('./components/SmileAssesment.js'));
const SmileAssessmentAll = React.lazy(() => import('./components/SmileAssessmentAll.js'));
const SmileAssessmentAllNew = React.lazy(() => import('./components/SmileAssessmentAllNew.js'));
const SmileAssessmentNewV13Q = React.lazy(() => import('./components/SmileAssessmentNewV13Q.js'));





const Congratulation = React.lazy(() => import('./components/Congratulation.js'));
const Thankyou = React.lazy(() => import('./components/ThankyouPage.js'));
const ThankyouNew = React.lazy(() => import('./components/ThankYouPageNew.js'));
const SitemapPage = React.lazy(() => import('./components/SitemapPage.js'));
const TeethBraces = React.lazy(() => import('./components/static-products/TeethBraces.js'));
const PabblyData = React.lazy(() => import('./components/PabblyData.js'));
const AlignerCost = React.lazy(() => import('./components/AlignerCost'));
const HomeAppointment = React.lazy(() => import('./components/HomeAppointment.js'));
const HomeAppointmentV1 = React.lazy(() => import('./components/HomeAppointmentV1.js'));
const AtHomeAppointment = React.lazy(() => import('./components/AtHomeAppointment.js'));
const AtHomeAppointmentV1 = React.lazy(() => import('./components/AtHomeAppoinmtentV1.js'));
const AtHomeAppointmentConsultation = React.lazy(() => import('./components/AtHomeAppointmentConsultation.js'));
const TeethBracesCost = React.lazy(() => import('./components/TeethBracesCost.js'));
const AlignersNearMe = React.lazy(() => import('./components/NearMePages/AlignersNearMe.js'));
const AlignersNearMeCity = React.lazy(() => import('./components/NearMePages/AlignersNearMeCity.js'));
const AlignersNearMeLocality = React.lazy(() => import('./components/NearMePages/AlignersNearMeLocality.js'));
const TeethBracesNearMe = React.lazy(() => import('./components/NearMePages/TeethBracesNearMe.js'));
const TeethBracesNearMeCity = React.lazy(() => import('./components/NearMePages/TeethBracesNearMeCity.js'));
const TeethBracesNearMeLocality = React.lazy(() => import('./components/NearMePages/TeethBracesNearMeLocality.js'));
const BookaScanPage = React.lazy(() => import('./components/BookaScanPage.js'));

const EnrollMyClinic = React.lazy(() => import('./pages/EnrollMyClinic.js'));
const NewAlignerPage = React.lazy(() => import('./components/Aligners/AlignerPage.js'))

const Glow = React.lazy(() => import('./pages/GlowPage.js'))
const GlowLandingPage = React.lazy(() => import('./pages/GlowNew.js'));
const GlowWebsitePage = React.lazy(() => import('./pages/GlowPageWebsite.js'));
const GlowNewWebsite = React.lazy(() => import('./pages/GlowNewWebsite.js'));
const DentistPage = React.lazy(() => import('./components/DentistPage/dentistPage.js'));













// import axiosInterceptor  from './components/axiosInterceptor';

function App() {

  const configData = useConfig();
  useDocumentTitle(configData?.company_name || 'Whistle');

  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <CanonicalTag />
        <Suspense fallback={<div></div>}>
          <Routes>
            <Route exact path="/" element={<NewHomePageV2 />}></Route>
            {/* <Route exact path="/new-home-page" element={<NewHome />}></Route> */}
            {/* <Route exact path="/home-page-optimized" element={<NewHomeOptimized />}></Route> */}
            {/* <Route exact path="/home-page-v2" element={<NewHomePageV2 />}></Route> */}
            {/* <Route exact path="/old-homepage" element={<Home />}></Route> */}
            <Route exact path="/about-us" element={<AboutUs />}></Route>
            <Route path="/privacy-policy" element={<ContentPage />} />
            <Route path="/refund-policy" element={<ContentPage />} />
            <Route path="/product-liability-terms" element={<ContentPage />} />
            <Route path="/product-terms-conditions" element={<ContentPage />} />

            <Route exact path="/location" element={<Location />}></Route>
            <Route exact path="/search" element={<Search />}></Route>
            <Route exact path="/location/:name" element={<LocationDetails />} />
            <Route exact path="/location-profile/:slug" element={<LocationDoctorProfile />} />
            <Route exact path="/location-MDU-profile/:slug" element={<LocationMduDoctorProfile />} />
            <Route exact path="/aligners" element={<NewAlignerPage />}></Route>
            <Route exact path="/:slug" element={<Product />}></Route>
            <Route exact path="/media" element={<Media />}></Route>
            <Route exact path="/treatment" element={<ConditionsTreatments />}></Route>
            <Route exact path="/careers" element={<Careers />}></Route>
            <Route exact path="/blog" element={<Blog />}></Route>
            <Route exact path="/blog/:slug" element={<BlogListing />}></Route>
            <Route exact path="/blog/:slug/:title" element={<BlogDetails />}></Route>
            <Route exact path="/blog-detail/:title" element={<BlogDetails />}></Route>
            <Route exact path="/doctor-profile/:author" element={<DoctorProfile />}></Route>
            <Route exact path="/faqs" element={<FaqPage />}></Route>
            <Route exact path="/smile-test" element={<SmileTest />}></Route>
            <Route exact path="/smile-assessment-questionnaire" element={<SmileTestNew />}></Route>
            <Route exact path="/smile-assessment-all-questionnaire" element={<SmileTestAll />}></Route>
            <Route exact path="/smile-assessment-new-v1-questionnaire" element={<SmileTestNewAll />}></Route>
            <Route exact path="/smile-assessment-new-v2-questionnaire" element={<SmileTestNewV13Q />}></Route>




            <Route exact path="/landing-page" element={<LandingPage />}></Route>
            <Route exact path="/landing-cost" element={<LandingPagenew />}></Route>
            <Route exact path="/landing-cost-new" element={<LandingPagenewDynamic />}></Route>
            <Route exact path="/landing-coupon" element={<LandingPageCoupon />}></Route>
            <Route exact path="/landing-cost-new-otp" element={<LandingPagenewDynamicOTP />}></Route>
            <Route exact path="/braces-cost" element={<BracesCost />}></Route>




            <Route exact path="/landing-plum" element={<LandingPagePulm />}></Route>
            <Route exact path="/landing-1mg" element={<LandingPageMg />}></Route>
            <Route exact path="/landing-page-brand" element={<LandingPageBrands />}></Route>



            <Route exact path="/landing-doctor" element={<LandingPageDoctor />}></Route>
            <Route exact path="/testimonials" element={<Testimonials />}></Route>
            <Route exact path="/smile-assessment-new" element={<SmileAssesmentNew />}></Route>
            <Route exact path="/smile-assessment" element={<SmileAssesment />}></Route>
            <Route exact path="/smile-assessment-all" element={<SmileAssessmentAll />}></Route>
            <Route exact path="/smile-assessment-new-v1" element={<SmileAssessmentAllNew />}></Route>
            <Route exact path="/smile-assessment-new-v2" element={<SmileAssessmentNewV13Q />}></Route>




            <Route exact path="/congratulation" element={<Congratulation />}></Route>
            <Route exact path="/thank-you" element={<ThankyouNew />}></Route>
            <Route exact path="/aligners-and-braces-new-otp" element={<LandingPageOtp />}></Route>
            <Route exact path="/treatment/:treatment_slug" element={<TreatmentPage />}></Route>
            <Route exact path="/sitemap" element={<SitemapPage />}></Route>
            <Route exact path="/teeth-braces" element={<TeethBraces />}></Route>
            <Route exact path="/pabbly-data" element={<PabblyData />}></Route>
            <Route exact path="/aligners-cost" element={<AlignerCost />}></Route>
            <Route path="/aligners-cost/:city" element={<AlignerCost />}></Route>
            <Route path="/home-appointment" element={<HomeAppointment />}></Route>
            <Route path="/home-appointment-v1" element={<HomeAppointmentV1 />}></Route>
            <Route path="/at-home-appointment" element={<AtHomeAppointment />}></Route>
            <Route path="/at-home-appointment-v1" element={<AtHomeAppointmentV1 />}></Route>
            <Route path="/landing-page/consultation" element={<AtHomeAppointmentConsultation />}></Route>
            <Route exact path="/teeth-braces-cost" element={<TeethBracesCost />}></Route>
            <Route exact path="/teeth-braces-cost/:city" element={<TeethBracesCost />}></Route>
            <Route exact path="/aligners-near-me" element={<AlignersNearMe />}></Route>
            <Route exact path="/aligners-near-me/:city" element={<AlignersNearMeCity />}></Route>
            <Route exact path="/aligners-near-me/:city/:sublocation" element={<AlignersNearMeLocality />}></Route>
            <Route exact path="/teeth-braces-near-me" element={<TeethBracesNearMe />}></Route>
            <Route exact path="/teeth-braces-near-me/:city" element={<TeethBracesNearMeCity />}></Route>
            <Route exact path="/teeth-braces-near-me/:city/:sublocation" element={<TeethBracesNearMeLocality />}></Route>
            <Route exact path="/book-scan" element={<BookaScanPage />}></Route>

            {/* <Route exact path="/partners" element={<EnrollMyClinic />}></Route>      */}
            <Route exact path="/partners" element={<DentistPage />}></Route>
            <Route exact path="/glow" element={<GlowNewWebsite />}></Route>
            <Route exact path="/glow-page" element={<GlowWebsitePage />}></Route>
            {/* <Route exact path="/glow-new" element={<GlowNewWebsite />}></Route> */}
            {/* <Route exact path="/glow-old" element={<Glow />}></Route> */}
            {/* <Route exact path="/dentist-page" element={<DentistPage />}></Route> */}







          </Routes>
        </Suspense>
      </Router>

    </div>
  );
}

export default App;
